// extracted by mini-css-extract-plugin
export default {"fields":"lRi9jb","month":"OLX2G5","day":"c3yzSA","year":"hwqy6D"};